import React, {Suspense} from 'react'
import {Canvas} from '@react-three/fiber'
import {OrbitControls, Environment, ContactShadows, SpotLight} from '@react-three/drei'

import * as THREE from 'three'

import Scene from './scene.component.jsx'

import { useAppState } from '../state/app.state.jsx'


export default function ThreeCanvas({...props}){
    const appState = useAppState()
    
    
    
    return (
        <Canvas shadows  dpr={[1, 2]} camera={{ position: [0, 0, 4], fov: 50 }}>
            <>
            <spotLight position={[0, 5, 0]} angle={0.25} penumbra={1} castShadow intensity={1} shadow-bias={-0.0001} />
            <spotLight position={[0, -5, 0]} angle={-0.25} penumbra={1} castShadow intensity={1} shadow-bias={-0.0001} />

            <Suspense fallback={null}>
              <ContactShadows rotation-x={Math.PI / 2} position={[0, -0.8, 0]} opacity={0.75} width={10} height={10} blur={1.5} far={0.8} />
              <Scene {...appState}/>
            </Suspense>
            <OrbitControls minPolarAngle={Math.PI / 2} maxPolarAngle={Math.PI / 2} enableZoom={false} zoom0 enablePan={false} />            
            </>
        </Canvas>
    )
}
